import { appConfig } from '../constants'
import { useCommonStore } from 'src/stores/common'
import { mapState } from 'pinia'

export default async ({ app, store }) => {
  app.mixin({
    data: function () {
      return {
        newCommonMeta: {
          link: {
            canonical: {
              rel: 'canonical',
              template(canonical) {
                let baseURL = process.env.SERVER
                  ? process.env.fullSsrUrl
                  : window.location.origin
                return canonical ? `${baseURL}${canonical}` : baseURL
              },
            },
          },
          meta: {
            title: {
              name: 'title',
              template(title) {
                return title || ''
              },
            },
            description: {
              name: 'description',
              template(description) {
                return description || ''
              },
            },
            ogType: {
              property: 'og:type',
              content: 'website',
            },
            ogUrl: {
              property: 'og:url',
              template(ogUrl) {
                let baseURL = process.env.SERVER
                  ? process.env.fullSsrUrl
                  : window.location.origin
                return ogUrl ? `${baseURL}${ogUrl}` : baseURL
              },
            },
            ogTitle: {
              property: 'og:title',
              template(ogTitle) {
                const commonStore = useCommonStore()
                let businessName =
                  commonStore.businessConfigurations?.businessName || ''
                if (businessName)
                  return ogTitle ? `${businessName} - ${ogTitle}` : businessName

                return ''
              },
            },
            ogDescription: {
              property: 'og:description',
              template(ogDescription) {
                const commonStore = useCommonStore()
                let businessName =
                  commonStore.businessConfigurations?.businessName || ''
                if (businessName)
                  return ogDescription
                    ? `${businessName} - ${ogDescription}`
                    : businessName

                return ''
              },
            },
            ogImage: {
              property: 'og:image',
              template(ogImg) {
                let defaultImg = `${appConfig.API_ROOT_URI}/v1/Configuration/Theme/Favicon?Tenant=${appConfig.TENANT}`
                return ogImg ? ogImg : defaultImg
              },
            },
          },
        },
      }
    },
    computed: {
      ...mapState(useCommonStore, ['businessConfigurations']),
      businessName() {
        return this.businessConfigurations?.businessName || ''
      },
      currentRoutePath() {
        return this.$route?.path || ''
      },
    },
  })
}
